import { useQuery } from "@tanstack/react-query";
import { fetchJson } from "@/lib/queryClient";

/**
 * What the reader's company has bought that changes what they can use:
 * SaleFish Intelligence and the Outlook / Gmail mailbox upgrade
 * (shared/companyPlans.ts). One key, so a plan change on Features & Billing
 * refreshes the launcher and Account Settings at once.
 */
export interface CompanyEntitlements {
  salefishIntelligence: boolean;
  emailIntegration: boolean;
}

export const COMPANY_ENTITLEMENTS_KEY = ["/api/company/entitlements"] as const;

export const companyEntitlementsQuery = {
  queryKey: COMPANY_ENTITLEMENTS_KEY,
  queryFn: () => fetchJson<CompanyEntitlements>("/api/company/entitlements"),
  staleTime: 5 * 60_000,
};

export function useCompanyEntitlements(enabled = true) {
  return useQuery({ ...companyEntitlementsQuery, enabled });
}
